import mutations from './eprofileVercsoport.mutations'
import actions from './eprofileVercsoport.actions'
import getters from './eprofileVercsoport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
